<script>
import { mapActions, mapGetters } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    components: {
        DatePicker,
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            form: {
                id: '',
                date: '',
                user_id: '',
                companies: [],
            },
            advance:{
                user_id:0,
                user:{
                    name:'',
                    last_name:''
                }
            },
            approved: false,
            send: false,
        }
    },
    methods: {
        closedModal() {
            this.form.id = '';
            this.form.user_id = '';
            const now = new Date();
            this.form.date = now.toISOString().slice(0, 10);
            this.form.companies = [];
            this.catalogue.companies_users=[];
            this.advance={
                user_id:0,
                user:{
                    name:'',
                    last_name:''
                }
            },
            this.sums=[0,0,0,0,0],
            this.send = false;
            this.errors = {};
            this.$modal.hide('addAdvance');
        },
        async saveAdvance() {
            this.send = true;
            const data_form = new FormData();
            data_form.append('id', this.form.id);
            data_form.append('user_id', this.form.user_id);
            data_form.append('date', this.form.date);

            const companiesArray = this.form.companies.map(company => ({
                id : company.id,
                amount: company.amount || 0,
            }));

            data_form.append('companies', JSON.stringify(companiesArray));

            let _endpoint = '/partners/advances';
            if (this.form.id != "") {
                data_form.append('_method', 'PUT');
                _endpoint = `/partners/advances/${this.form.id}`;
            }
            try {
                let { data } = await request.postMedia(_endpoint, data_form)
                if (data) {
                    this.successNotification(data.message);
                    Event.$emit('event-load-advances');
                    this.closedModal();
                }
            } catch (error) {
                this.send = false;
                this.errors = {};
                if (error.response) {

                    this.errors = await this.errorNotification(error);
                    this.errorNotificationMessage(this.errors[Object.keys(this.errors)[0]][0]);
                }
            }
        },
		addCompanyRow() {
			const nextOrder = (this.form.companies?.length || 0) + 1;
			this.form.companies.push({
				id: '',
				amount: 0,
				order: nextOrder,
			});
		},
		removeCompanyRow(index) {
			this.form.companies.splice(index, 1);
			this.form.companies.forEach((c, i) => c.order = i + 1);
		},
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
			errorNotificationMessage: 'alert/errorMessage',
        }),
    },
    watch: {
        'form.user_id'(value) {
            this.catalogue.get_companies_users(value);
            if(this.form.id=='')
                this.form.companies = [];
        },
    },
    mounted() {
		this.catalogue.get_users_profile(8);
    },
    created() {
        Event.$on("event-show-addAdvance", async (advance,prop_edit) => {
            if (advance.id) {
                this.advance=advance;
                if(prop_edit){
                    this.load = true;
                    this.form.id = advance.id;
                    this.form.user_id = advance.user_id;
                    this.form.date = advance.date;
                }
                let vm=this;
                advance.companies.forEach(c=>{
                    vm.form.companies.push({
                        id: c.company.id,
                        name:c.company.name,
                        amount: c.amount
                    });

                })
            }else{
                const now = new Date();
                this.form.date = now.toISOString().slice(0, 10);
            }
            this.$modal.show('addAdvance');
        });
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    },
}
</script>
<template>
    <modal name="addAdvance" :width="'80%'" :maxHeight="300" :height="'auto'" v-bind:click-to-close="false">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <form @submit.prevent="saveAdvance" method="post" enctype="multipart/form-data">
            <button :disabled="send" type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                    class="fa-solid fa-xmark"></i> </button>
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel" v-if="prop_edit">Agregar Adelantos</h5>
                <h5 class="modal-title" id="exampleModalLabel" v-else>Detalle de Adelanto</h5>
            </div>
            <div class="modal-body">
                <div class="row">

                    <div class="col-md-6 mt-3" v-if="prop_edit">
                        <label>Socio</label>
						<select v-model="form.user_id" class="form-control">
							<option value=""> Seleccionar usuario </option>
							<option v-for="(user, index) in catalogue.users_profile" :value="user.id" :key="index">
								{{ user.name }} {{ user.last_name }}</option>
						</select>
                        <div v-if="errors && errors.user_id" class="text-danger">
                            {{ errors.user_id[0] }}
                        </div>
                    </div>

                    <div class="col-md-6 mt-3" v-else>
                        <label>Socio</label>
                        {{ advance.user.name }} {{ advance.user.last_name }}
                    </div>

                    <div class="col-md-6 mt-3" v-if="prop_edit">
                        <label>Fecha</label>
                        <date-picker v-model="form.date" required="required"
                             valueType="format"></date-picker>
                        <div v-if="errors && errors.date" class="text-danger">{{ errors.date[0] }}</div>
                    </div>

                    <div class="col-md-6 mt-3" v-else>
                        <label>Fecha</label>
                        {{ advance.date | toDateTime }}
                    </div>

                    <div class="col-12 mt-3">
                        <hr>
                        <div class="d-flex justify-content-between align-items-center">
                        <h5 class="mb-0">Empresas:</h5>
                        <button type="button" class="btn btn-sm btn-outline-info" @click="addCompanyRow()" v-if="prop_edit">
                            <i class="fa fa-plus"></i> Agregar
                        </button>
                        </div>
                        <hr class="mt-2">
                        <div class="table-responsive">
                            <table class="table table-bordered text-center text-sm">
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Adelanto</th>
                                        <th v-if="prop_edit">Acción</th>
                                    </tr>
                                </thead>
                                <tbody v-if="form.companies.length>0 && (!prop_edit || catalogue.companies_users.length>0 )">
                                    <tr v-for="(company, index) in form.companies" :key="index">
                                        <td>
                                            <div v-if="prop_edit">
                                                <select type="text" class="form-control" v-model="company.id">
                                                    <option v-for="(comp, index2) in catalogue.companies_users" :value="comp.id" :key="index2">
                                                        {{ comp.name }}</option>
                                                </select>
                                                <div v-if="errors && errors['company-'+company.id+'-company']" class="text-danger">{{
                                                    errors['company-'+company.id+'-company'][0] }}</div>
                                            </div>
                                            <div v-else>
                                                {{ company.name }}
                                            </div>
                                        </td>
                                        <!-- <td><span :id="'rfc-'+index">{{ company.rfc }}</span></td> -->
                                        <td v-if="prop_edit">
                                            <input type="number"
                                                class="form-control" v-model="company.amount"
                                                :id="'amount-' + index" step="0.01">
                                                <div v-if="errors && errors['company-'+company.id+'-amount']" class="text-danger">{{
                                                    errors['company-'+company.id+'-amount'][0] }}</div>
                                        </td>
                                        <td v-else>
                                            {{ company.amount | toCurrency}}
                                        </td>
                                        <td class="text-center" v-if="prop_edit">
                                            <button type="button" class="btn btn-sm btn-outline-danger"
                                                @click="removeCompanyRow(index)">
                                                <i class="fa fa-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td align="center" colspan="5">Sin resultados.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="errors && errors.companies" class="text-danger">{{ errors.companies[0] }}</div>
                    </div>
                    <div class="col-md-12">
                        <hr>
                        <button v-if="prop_edit" :disabled="send" type="submit"
                            class="btn float-right btn-outline-success">
                            <span v-if="send">
                                <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                            </span>
                            <span v-else>
                                <i class="fas fa-save"></i> Guardar
                            </span>
                        </button>
                        <button type="button" :disabled="send" @click="closedModal()"
                            class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.image-upload>input {
    display: none;
}

.del {
    position: absolute;
    right: 0px;
    margin: 10px;
}
</style>